// 服务发布
const ServicesInvestmentPromotion = () => import('@/views/services/investmentPromotion/index.vue') // 发布招商
const ServicesSpace = () => import('@/views/services/space/index.vue') // 发布空间
const ServicesGreenPlants = () => import('@/views/services/greenPlants/index.vue') // 发布绿植

export default {
  ServicesInvestmentPromotion,
  ServicesSpace,
  ServicesGreenPlants
}
